import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import { MediaQuery, Size } from '../../constant/breakpoint.ts';

import styled from 'styled-components';

export const NavbarContainer = styled(Navbar)({
    height: '100px',
    paddingTop: '0px',
    paddingBottom: '0px',
    backgroundColor: '#6F5649',
    [MediaQuery[Size.NAV]]: {
        height: 'auto'
    },
});

export const ContainerExtend = styled(Container)({
    height: '100%',
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
});

export const TabDiv = styled('div')(
    ({ isActive }) => ({
    height: '60px',
    fontSize: '32px',
    fontWeight: 'normal',
    textAlign: 'center',
    color: isActive ? '#A0865B' : 'black',
    '@media (max-width: 1000px)': {
        fontSize: '24px',
    },
}));

export const ActiveBox = styled('div')(({ isActive }) => ({
    background: isActive ? 'white' : '#6F5649', // Different color for active state
    color: isActive ? 'black' : '#FFCC79',
    padding: '0px 30px',
    height: '100%',
    borderRadius: '25px 25px 0px 0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    width: isActive ? '100%' : '100%',
    '@media (max-width: 1400px)': {
        width: isActive ? '100%' : '100%',
        padding: '0px 20px',
    },
    '@media (max-width: 1200px)': {
        padding: '0px 13px',
        width: isActive ? 'auto' : '100%',
    },
}))


export const NavbarMenu = styled(Navbar.Collapse)({
    marginLeft: "40px",
    marginTop: "0px",
    height: '100%',
    paddingTop: '15px',
    [MediaQuery[Size.XL]]: {
        marginLeft: "20px",
    },
    [MediaQuery[Size.NAV]]: {
        marginLeft: "0px",
        marginTop: "0px",
    },
});

export const NavbarFlex = styled(Nav)({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "left",
    color: "black",
    fontFamily : "Gotham",
    fontSize: "16px",
    height: '100%',
})

export const NavLink = styled(Nav.Link)({
    paddingTop: "0px",
    paddingBottom: "0px",
    height: '100%',
    width: 'auto',
})
